import React, { useState, useEffect } from 'react';

const DateOfBirthPicker = ({ dobValue, onDobChange }) => {
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');

  const months = [
    '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'
  ];

  const days = Array.from({ length: 31 }, (_, i) => (i + 1).toString().padStart(2, '0'));
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 121 }, (_, i) => (currentYear - i).toString());

  // useEffect(() => {
  //   if (dobValue) {
  //     const [mm, dd, yyyy] = dobValue.split('/');
  //     setMonth(mm);
  //     setDay(dd);
  //     setYear(yyyy);
  //   }
  // }, [dobValue]);

  const handleSelectChange = (type, value) => {
    const newDay = type === 'day' ? value : day;
    const newMonth = type === 'month' ? value : month;
    const newYear = type === 'year' ? value : year;

    if (newDay && newMonth && newYear) {
      onDobChange(`${newMonth}/${newDay}/${newYear}`);
    }
  }

  return (
    <div style={{ marginTop: 0 }} className="w-full p-2 border rounded">
      <select value={month} onChange={(e) => { setMonth(e.target.value); handleSelectChange('month', e.target.value); }}>
        <option value="">Month</option>
        {months.map(m => <option key={m} value={m}>{m}</option>)}
      </select>

      <select value={day} onChange={(e) => { setDay(e.target.value); handleSelectChange('day', e.target.value); }}>
        <option value="">Day</option>
        {days.map(d => <option key={d} value={d}>{d}</option>)}
      </select>

      <select value={year} onChange={(e) => { setYear(e.target.value); handleSelectChange('year', e.target.value); }}>
        <option value="">Year</option>
        {years.map(y => <option key={y} value={y}>{y}</option>)}
      </select>
    </div>
  );
}

export default DateOfBirthPicker;
